import Notes from './views/Notes';
import Observations from './views/Observations';
import BloodResults from './views/BloodResults';
import Imaging from './views/Imaging';
import RequestBloods from './views/MedicationChart';
import Overview from './views/Overview';
import { useParticipantEPR } from './ParticipantEPRContext';

export default function MainContent({ selectedTab }) {
  const { loading } = useParticipantEPR();

  return (
    <div className="content">
      {selectedTab === 'notes' && <Notes />}
      {selectedTab === 'observations' && <Observations />}
      {selectedTab === 'bloods' && <BloodResults />}
      {selectedTab === 'imaging' && <Imaging />}
      {selectedTab === 'meds' && <RequestBloods />}
      {selectedTab === 'overview' && <Overview />}
    </div>
  );
}